module.exports = {"type":"Beginne zu schreiben...","enter":"Drücken Enter","vertical":"zum navigieren","horizontal":"zum navigieren","select":"zum auswählen","esc":"schließen"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/shortcuts.json
// module id = 514
// module chunks = 248 1666